import React from 'react';

const Footer = () => {
  return (
    <footer className="bg-slate-100 border-t border-slate-200 py-2 mt-auto cursor-default select-none">
  <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
    <div className="flex flex-col md:flex-row items-center justify-center md:justify-between gap-2">
      
      <div className="flex items-center gap-2">
        <img
          src="/images/cclogo.png"
          alt="CircularCarbon Logo"
          className="w-12 h-6"
        />
        <span className="text-xs font-medium text-slate-600">
          Powered by CircularCarbon Technologies
        </span>
      </div>

      <div className="text-xs text-slate-500">
        &copy; {new Date().getFullYear()} All rights reserved.
      </div>

    </div>
  </div>
</footer>

  );
};

export default Footer;